export default {"src":"/_next/static/media/check.b3d88048.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};